import React, { useState } from "react";
import axios from "axios";
import ConfirmationDialog from "../modal/confirmationDialog";

const PrazoTab = ({ responsePrazos, dataFormato }) => {
    // Estados para o modal de confirmação
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [selectedPrazoId, setSelectedPrazoId] = useState(null);

    // Função para confirmar o prazo (marcando-o como encerrado)
    function confirmPrazo(n) {
        axios
            .put(
                `/api/confirm/deadline/${n}`, // Rota para marcar status como "Encerrado"
                {
                    withCredentials: true,
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            )
            .then(window.location.reload())
            .catch((error) => {
                console.error("Erro ao confirmar prazo:", error);
            });
    }

    // Abre o modal de confirmação e define o prazo selecionado
    const handleOpenConfirmModal = (prazoId) => {
        setSelectedPrazoId(prazoId);
        setOpenConfirmModal(true);
    };

    // Fecha o modal e limpa o ID selecionado
    const handleCloseModals = () => {
        setOpenConfirmModal(false);
        setSelectedPrazoId(null);
    };

    return (
        <div className="tab-pane fade" id="segunda-aba" role="tabpanel">
            <div className="card-body table-responsive p-0">
                <table className="table table-bordered mt-10">
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th>Data</th>
                            <th>Status</th>
                            <th style={{ width: 130 }}>Confirmar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {responsePrazos &&
                            responsePrazos.map((prazo) => (
                                <tr key={prazo.id}>
                                    <td>{prazo.descricao}</td>
                                    <td>{dataFormato(prazo.data)}</td>
                                    <td>{prazo.status}</td>
                                    <td>
                                        {/* Botão de confirmação só aparece se o prazo estiver em aberto */}
                                        {prazo.status === "Aberto" && (
                                            <button
                                                className="btn btn-success"
                                                type="button"
                                                onClick={() =>
                                                    handleOpenConfirmModal(
                                                        prazo.id
                                                    )
                                                }
                                                title="Confirmar Recebimento">
                                                <i className="fa fa-check" />
                                            </button>
                                        )}
                                        {/* Não há opções de edição ou exclusão para o cliente */}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            {/* Modal de confirmação para confirmar o prazo */}
            <ConfirmationDialog
                open={openConfirmModal}
                title="Confirmar Prazo"
                message="Você tem certeza que deseja confirmar este prazo? Esta ação marcará o prazo como encerrado e não poderá ser desfeita."
                onCancel={handleCloseModals}
                onConfirm={() => {
                    confirmPrazo(selectedPrazoId);
                    handleCloseModals();
                }}
                confirmButtonColor="success"
            />
        </div>
    );
};

export default PrazoTab;
